<div class="wrapper">
  <ul>
    <li>
      <div class="cursor-pointer my-1 link-primary" data-bs-toggle="modal"
           data-bs-target="#createProject">Create project
      </div>
    </li>
    <li *ngFor="let project of projectService.getProjects()"
        (click)="choseProject(project.id)">{{ project.name }}
    </li>
  </ul>

  <div class="modal fade" id="createProject" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Create new project</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-4" [innerHTML]="'app.project.description' | translate"></div>
            <div class="col-12">
              <label class="form-label" for="project_name" translate>app.project.name</label>
              <input type="text" id="project_name" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="project.name"
                     placeholder="{{'app.project.name.example' | translate}}"/>
            </div>
            <div class="col-12">
              <label class="form-label" for="project_description" translate>app.project.description</label>
              <input type="text" id="project_description" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="project.description"
                     placeholder="{{'app.project.description.example' | translate}}"/>
            </div>
            <div class="col-12" *ngIf="project.error">{{ project.error }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal" translate>app.buttons.cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary"
                  (click)="projectService.create($event, project)" translate>app.buttons.create
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
